module.exports = __webpack_public_path__ + "images/1a513a206f361df5af1021dde6a0b018.png";